export default __webpack_public_path__ + "static/media/wutzu.100776e1.png";